import { render, staticRenderFns } from "./importPayRollData.vue?vue&type=template&id=5f5455e2&scoped=true"
import script from "./importPayRollData.vue?vue&type=script&lang=js"
export * from "./importPayRollData.vue?vue&type=script&lang=js"
import style0 from "./importPayRollData.vue?vue&type=style&index=0&id=5f5455e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5455e2",
  null
  
)

export default component.exports